<template>
  <div
    class="editor-module-container"
  >
    <div class="editor-module-title">
      <div
        class="left-content"
        @click="clickRenameModule('', cvDetail.submodule_info.opus_title)"
      >
        <img v-if="moduleIcon" class="module-icon" :src="moduleIcon" alt="" />
        {{ cvDetail.submodule_info.opus_title }}
        <i class="iconfont iconedit-"></i>
        <div v-if="issueCount" class="module-issue-count">
          {{ issueCount }} 项待修复
        </div>
      </div>
      <div class="right-content">
        <i v-if="opus.length > 1" class="iconfont iconpaixu">
          <ExperienceSequence
            :list="opus"
            displayKey="title"
            @draggableChange="sequenceChange"
          />
        </i>
        <i
          class="iconfont iconshanchujianli"
          @click="handleClickRemoveModule"
        ></i>
      </div>
    </div>
    <div class="editor-form-list">
      <transition-group :name="displayAnimation ? 'list' : ''">
        <div
          v-for="item in opus"
          :key="item.id"
          :id="`experience${item.id}`"
          class="editor-form-content"
          @click="editItem(item, 'sameInfo')"
        >
          <div class="form-item-header">
            <div class="form-item-title">
              <div class="form-item-name">{{ item.title }}</div>
              <div class="form-item-edit-content">
                <i
                  class="iconfont iconshanchujianli"
                  @click.stop="removeExperience(item)"
                ></i>
                <i
                  class="iconfont iconchevron-down"
                  :class="{ active: editId === item.id }"
                  @click.stop="editItem(item, 'sameInfo')"
                ></i>
              </div>
            </div>
            <div
              v-if="item.url"
              class="form-item-content"
            >
              <div class="content-text">{{ item.url }}</div>
            </div>
          </div>
          <el-collapse-transition>
            <div
              v-show="editId === item.id"
              class="editor-module-content editor-base-form"
              @click.stop
            >
              <EditorInput
                v-model="item.title"
                placeholder="请输入作品名称"
                clearable
                label="作品名称"
                style="width: 100%"
              />
              <EditorInput
                v-model="item.url"
                placeholder="请粘贴作品链接"
                clearable
                label="作品链接"
                style="width: 100%"
              />
              <div class="opu-qr-item-content">
                <div
                  class="flex items-center"
                  style="margin-bottom: 16px"
                >
                  <span class="title">作品二维码</span>
                  <span class="tips">（线下投递 HR 可通过扫码查看作品集）</span>
                </div>
                <div class="qr-image-content flex items-center justify-center">
                  <img
                    v-if="item.qrcode"
                    class="w-full h-full cursor-pointer"
                    :src="item.qrcode"
                    alt=""
                    @click="clickUploadRef"
                  />
                  <i
                    v-else
                    class="iconfont iconxinjianjianli cursor-pointer"
                    @click="clickUploadRef"
                  ></i>
                </div>
              </div>
              <div class="complete-button-wrapper">
                <CompleteButton
                  text="保存"
                  :disabled="experienceEmpty('opus', item.id, keys)"
                  @clickBtn="saveExperience(item.id, 'click')"
                />
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </transition-group>
      <input
        ref="uploadInputRef"
        type="file"
        accept="image/*"
        style="display: none"
        @change="qrcodeUpload"
      />
      <div
        v-if="displayAddBtn"
        class="editor-module-add"
        @click="clickAddExperience"
      >
        <i class="iconfont iconplus-circle"></i>
        <span>添加一段{{ cvDetail.submodule_info.opus_title }}</span>
      </div>
    </div>
    <RenameModuleModal
      ref="renameModalRef"
      @confirm="confirmModuleRename($event, 'opus')"
    />
    <EditorCropperImage
      ref="cropperImageRef"
      title="作品二维码"
      @uploadConfirm="clickComplete"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { editorFormMixin } from '../../mixins/editor-form';
import moment from 'moment';
import EditorInput from '../EditorInput/EditorInput.vue';
import EditorSelect from '../EditorSelect/EditorSelect.vue';
import EditorDatePickerRange from '../EditorDatePickerRange/EditorDatePickerRange.vue';
import EditorCityPicker from '../EditorCityPicker/EditorCityPicker.vue';
import EditorAutoComplete from '../EditorAutoComplete/EditorAutoComplete.vue';
import EditorRichText from '../EditorRichText/EditorRichText.vue';
import ExperienceSequence from '../ExperienceSequence/ExperienceSequence.vue';
import RenameModuleModal from '../RenameModuleModal/RenameModuleModal.vue';
import EditorCropperImage from '../EditorCropperImage/EditorCropperImage.vue';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
import { uploadMixin } from '../../mixins/upload';

const keys = ['title', 'url', 'qrcode'];

export default {
  name: 'EditorWork',
  mixins: [editorFormMixin, uploadMixin],
  components: {
    EditorInput,
    EditorSelect,
    EditorDatePickerRange,
    EditorCityPicker,
    EditorAutoComplete,
    EditorRichText,
    ExperienceSequence,
    RenameModuleModal,
    EditorCropperImage,
    CompleteButton,
  },
  props: {
    editId: {
      type: [String, Number],
      default: '',
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keys,
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail', 'opus']),
    ...mapState('cvs', ['section_titles']),
    displayAddBtn() {
      return this.opus.every((item) => item.id !== 'opus-edit');
    },
  },
  watch: {
    editId(_, oldVal) {
      if (this.clickSaveBtn) return;
      if (oldVal === 'opus-edit') {
        this.checkModuleEmpty('opus', oldVal, keys);
      } else if (oldVal) {
        this.saveExperience(oldVal);
      }
    },
  },
  filters: {
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('YYYY.MM');
    },
  },
  methods: {
    saveExperience(id, operation) {
      const payload = this.opus.find((item) => item.id === id);
      if (!payload) return;
      payload.lang = this.cvDetail.basic_info.lang;
      this.updateFormExperience(payload, 'opus', operation);
    },
    sequenceChange() {
      this.experienceSequenceChange('opus');
    },
    async handleClickRemoveModule() {
      const confirm = await this.$wondercv.showConfirm({
        title: '温馨提示',
        content: `确定要删除${this.cvDetail.submodule_info.opus_title}吗？`,
        warningText: '模块删除后无法恢复',
        confirmText: '确认',
        cancelText: '取消',
      });
      if (confirm) {
        this.clickRemoveModule('opus');
      }
    },
    clickAddExperience() {
      this.$store.commit('editor/setModuleData', {
        type: 'opus',
        info: [
          ...(this.$store.state.editor?.opus || []),
          {
            id: 'opus-edit',
            title: '',
            url: '',
            qrcode: '',
          },
        ],
      });
      this.$emit('editItem', 'opus-edit');
    },
    async removeExperience(item) {
      try {
        const confirm = await this.$wondercv.showConfirm({
          title: '温馨提示',
          content: `确定要删除${item.title || ''}吗？`,
          warningText: '经历删除后无法恢复',
          confirmText: '确认',
          cancelText: '取消',
        });
        if (confirm) {
          this.clickRemoveExperience(item, 'opus');
        }
      } catch (error) {
        console.log(error);
      }
    },
    editItem(item, sameInfo) {
      this.$emit('editItem', item.id, sameInfo);
    },
    async qrcodeUpload() {
      try {
        const url = await this.uploadInputChange();
        if (url) {
          this.$refs.cropperImageRef.show({
            img: url,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async clickComplete(file) {
      try {
        const formItem = this.opus.find((item) => item.id === this.editId);
        if (formItem) {
          const url = await this.uploadFileToOSS(file);
          formItem.qrcode = url;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
@import '../../styles/editor.scss';
.opu-qr-item-content {
  .title {
    color: $form-label-color;
  }
  .tips {
    color: #5b616e;
  }
  .qr-image-content {
    width: 100px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    background-color: $upload-bg-color;
    .iconxinjianjianli {
      color: #6e7788;
      font-size: 24px;
    }
  }
}
</style>
